import { languageService } from "../../../../Language/language.service";

const dateFormat = "MM-DD-yy";
export const deleteHosRecordsSchema = {
  title: languageService("Search Mistaken HOS Records"),
  id: "hosSearchFiltersFormSchema",
  returnOnlyEnabledFields: false,
  stateTitle: {},
  sections: [
    {
      id: "typeSelectionSection",
      fields: [
        {
          id: "employeeEmail",
          type: "select",
          labelValue: languageService("Employee"),
          required: true,
          selectOptions: [],
          col: 4,
        },
        {
          id: "startDate",
          type: "date",
          labelValue: languageService("Start Date"),
          format: dateFormat,
          required: true,
          col: 4,
        },
      ],
    },

    {
      id: "footerActionsSection",
      fields: [
        {
          id: "removeRecords",
          type: "button",
          labelValue: languageService("Remove"),
          action: "submit",
          callback: "removeRecords",
          position: "footer",
          col: 12,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/diagnostics/RemoveHosRecords/Schemas/schema.js